class CustomQuickAdd {
    constructor() {
        /** @type {(HTMLElement & { showDialog: () => void, closeDialog: () => Promise<void> }) | null} */
        this.dialogComponent = document.getElementById('popup-quick-add');
        /** @type {HTMLDialogElement | null} */
        this.dialog = this.dialogComponent?.querySelector('dialog') ?? null;
        /** @type {HTMLElement | null} */
        this.inner = document.getElementById('quick-add-popup-inner');
        /** @type {AbortController | null} */
        this.abortController = null;

        this.initEvents();
    }

    initEvents() {
        document.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) return;

            const trigger = event.target.closest('[data-quick-add-trigger]');
            if (trigger instanceof HTMLElement) {
                event.preventDefault();
                this.open(trigger.dataset.productUrl, trigger.dataset.variantId);
                return;
            }

            const dialog = this.dialog;
            if (!dialog) return;

            const submitBtn = event.target.closest('[data-quick-add-submit]');
            if (submitBtn instanceof HTMLButtonElement && dialog.contains(submitBtn) && !submitBtn.disabled) {
                this.addToCart(submitBtn);
            }
        });

        document.addEventListener('change', (event) => {
            if (!(event.target instanceof HTMLInputElement)) return;

            const dialog = this.dialog;
            if (!dialog) return;

            if (event.target.matches('.quick-add-popup-variants input[type="radio"]') && dialog.contains(event.target)) {
                this.selectVariant(event.target);
            }
        });
    }

    /**
     * @param {string | undefined} productUrl
     * @param {string | undefined} variantId
     */
    async open(productUrl, variantId) {
        const dialogComponent = this.dialogComponent;
        const dialog = this.dialog;
        const inner = this.inner;
        if (!dialogComponent || !dialog || !inner || !productUrl) return;

        dialog.classList.add('loading');
        dialogComponent.showDialog();

        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
            const url = new URL(productUrl, window.location.origin);
            const localePrefix = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i)?.[1] ?? '';
            if (localePrefix && !url.pathname.startsWith(localePrefix + '/')) {
                url.pathname = localePrefix + url.pathname;
            }
            if (variantId) url.searchParams.set('variant', variantId);
            url.searchParams.set('section_id', 'custom-quick-add-popup');

            const response = await fetch(url.toString(), { signal: this.abortController.signal });

            if (!response.ok) {
                throw new Error(`Quick add fetch failed: HTTP ${response.status}`);
            }

            inner.innerHTML = await response.text();
        } catch (error) {
            if (error instanceof Error && error.name !== 'AbortError') {
                console.error('Erreur quick add :', error);
                this.close();
            }
            return;
        } finally {
            dialog.classList.remove('loading');
        }
    }

    close() {
        this.dialogComponent?.closeDialog();
    }

    /** @param {HTMLInputElement} input */
    selectVariant(input) {
        const dialog = this.dialog;
        if (!dialog) return;

        const submitBtn = dialog.querySelector('[data-quick-add-submit]');
        const priceEl = dialog.querySelector('[data-quick-add-price]');

        if (submitBtn instanceof HTMLElement) {
            submitBtn.dataset.variantId = input.value;
            submitBtn.toggleAttribute('disabled', input.dataset.available === 'false');
        }
        if (priceEl && input.dataset.price) {
            priceEl.textContent = input.dataset.price;
        }

        dialog.querySelectorAll('.quick-add-popup-variant-label').forEach((el) => {
            el.classList.toggle('selected', el.contains(input));
        });
    }

    /** @param {string | undefined} src */
    swapMainImage(src) {
        if (!src || !this.dialog) return;

        const mainImage = this.dialog.querySelector('.quick-add-popup-main-image img');
        if (!(mainImage instanceof HTMLImageElement)) return;

        mainImage.removeAttribute('srcset');
        mainImage.src = src;
    }

    /** @param {HTMLElement} submitBtn */
    addToCart(submitBtn) {
        const dialog = this.dialog;
        const variantId = submitBtn.dataset.variantId;
        if (!dialog || !variantId) return;

        const productRoot = dialog.querySelector('.quick-add-popup-product');
        /** @type {Record<string, string>} */
        const my_properties = {};

        if (productRoot instanceof HTMLElement) {
            if (productRoot.dataset.color) {
                my_properties.Color = productRoot.dataset.color;
            }
            if (productRoot.dataset.title) {
                my_properties.Title = productRoot.dataset.title;
            }
        }

        customAddToCart(variantId, 1, my_properties);
        this.close();
    }
}

window.addEventListener("load", function() {
    const quickAddCustom = new CustomQuickAdd();
});
